import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Message, SpinnerService } from 'shared-components';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { ConfiguracionContextService } from '../../../context/configuracion-context.service';
import { ConfiguracionService } from '../../../services/configuracion.service';

@Component({
    selector: 'app-formatos-etiqueta',
    templateUrl: './formatos-etiqueta.component.html'
})
export class FormatosEtiquetaComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 5;
    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public configuraciones;
    public formatosAsociados;
    public new = false;
    public editables;

    public showError: boolean;
    public mensajes = new Array<Message>();

    @Input() grupoEtiquetaId;
    @Input() desGrupoEtiqueta;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvoider: DataProvider,
        private readonly _configuracionContext: ConfiguracionContextService,
        private readonly _configuracionService: ConfiguracionService
    ) { }

    ngOnInit() {
        const promises: Promise<any>[] = [];
        promises.push(this.getConfiguracionesFormatoEtiqueta());
        Promise.all(promises).then(
            () => {
                this.getFormatosEtiqueta();
            }, (error) => {
                console.log('Promise rejected with ' + JSON.stringify(error));
            }
        ).catch(e => console.log(e));
    }

    public newFormatoEtiqueta() {
        this.new = true;
        this.editables = '';
    }

    public editableChanged(formatoEtiqueta) {
        this.editables = formatoEtiqueta;
        this.new = false;
    }

    public close() {
        this.refresh.emit(false);
    }

    public toRefresh(value) {
        this.new = false;
        this.editables = '';
        this.getFormatosEtiqueta();
    }

    public pageChange(page) {
        this.currentPage = page - 1;
        this.getFormatosEtiqueta();
    }

    public getFormatosEtiqueta() {
        let filters = {
            grupoEtiquetaId: this.grupoEtiquetaId,
            includeFile: true,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };
        this._spinnerService.showSpinner();
        this._configuracionService.getFormatosEtiqueta(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.formatosAsociados = resp.lista;
        }, (error) => {
            this.showError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public getConfiguracionesFormatoEtiqueta(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this._configuracionService.getConfiguracionFormatoEtiqueta().toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.configuraciones = resp;
                setTimeout(resolve, 1);
            });
        });

    }

    public showMessages(mensaje) {
        this.showError = true;
        if (mensaje.includes('error') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

}
